import { Field } from "formik";
import React from "react";

const SimpleNumber = ({ field, errors, touched, values, setFieldValue, isDisabled = false }) => {
  return (
    <div className="number-input">
      <button
        type="button"
        className={`increment ${isDisabled ? "disabled" : ""}`}
        disabled={isDisabled}
        onClick={() => {
          const currentValue = values[`${field.id}`] || 0;
          setFieldValue(`${field.id}`, currentValue + 1);
        }}
      >
        <svg width="17" height="11" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.15791 0.248932L0.294273 8.98339C0.106364 9.16973 8.43111e-08 9.42982 8.10243e-08 9.70544L1.15861e-08 15.5284C7.02628e-09 15.9108 0.205636 16.2582 0.524727 16.4154C0.845591 16.5707 1.21964 16.5067 1.47845 16.2505L9.75 8.10024L18.0198 16.2505C18.2804 16.5067 18.6544 16.5727 18.9735 16.4154C19.2944 16.2582 19.5 15.9108 19.5 15.5284L19.5 9.70544C19.5 9.42982 19.3919 9.16973 19.2075 8.98339L10.3439 0.248932C10.007 -0.0829772 9.49295 -0.0829772 9.15791 0.248932Z"
            fill="white"
          />
        </svg>
      </button>
      <Field
        disabled={isDisabled}
        className={errors[`${field.id}`] && touched[`${field.id}`] ? "input-error" : ""}
        name={`${field.id}`}
        type="number"
        value={values[`${field.id}`]}
        onChange={(e) => {
          const inputValue = e.target.value;
          setFieldValue(`${field.id}`, inputValue === "" ? "" : parseInt(inputValue, 10) || 0);
        }}
        placeholder={field.placeholder}
      />
      <button
        type="button"
        className={`decrement ${isDisabled ? "disabled" : ""}`}
        disabled={isDisabled}
        onClick={() => {
          const currentValue = values[`${field.id}`] || 0;
          setFieldValue(`${field.id}`, Math.max(0, currentValue - 1));
        }}
      >
        <svg width="17" height="11" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10.3421 16.7511L19.2057 8.01661C19.3936 7.83027 19.5 7.57018 19.5 7.29456L19.5 1.47159C19.5 1.08921 19.2944 0.741774 18.9753 0.584554C18.6544 0.429275 18.2804 0.493327 18.0215 0.749538L9.75 8.89976L1.48023 0.749537C1.21964 0.493327 0.845591 0.427333 0.526501 0.584553C0.205637 0.741773 1.88159e-06 1.08921 1.86488e-06 1.47159L1.61035e-06 7.29456C1.5983e-06 7.57018 0.108137 7.83027 0.292499 8.01661L9.15614 16.7511C9.49295 17.083 10.007 17.083 10.3421 16.7511Z"
            fill="#1C2B58"
          />
        </svg>
      </button>
    </div>
  );
};

export default SimpleNumber;
